<template>
  <Bar :data="data" :options="options" />
</template>

<script>
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
  import { Bar } from 'vue-chartjs';

  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  export default {
    name: 'BarChart',
    components: {
      Bar,
    },
    extends: Bar,
    props: ['data', 'options'],
    data() {
      return {};
    },
  };
</script>
